/* eslint no-useless-escape: 0, no-console: 0 */
import AutoComplete from '../vendor/js-autocomplete-custom';
import { searchSuggestion } from './Seo';

export default class SearchSuggestJS {
  constructor(options) {
    if (!document.querySelectorAll(options.parentEl).length) {
      return;
    }

    // eslint-disable-next-line
    String.prototype.html = function () {
      return this.replace(/[\u00A0-\u9999<>\&]/gim, (s) => `&#${s.charCodeAt(0)};`);
    };

    const input = document.querySelector(options.input);

    this.setup({
      inputEl: input,
      parentEl: options.parentEl,
      minChars: options.minChars,
    });
  }

  setup(options) {
    const url = options.inputEl.dataset.suggest;
    let cluster = '';
    if (options.inputEl.dataset.cluster) {
      cluster = `&cluster=${encodeURIComponent(options.inputEl.dataset.cluster)}`;
    }

    new AutoComplete({
      selector: options.inputEl,
      parentElement: document.querySelector(options.parentEl),
      minChars: options.minChars,
      cache: false, // Cache is pretty buggy
      source: (term, suggest) => {
        window.axios({
          method: 'GET',
          url: `${url}?q=${encodeURIComponent(term)}${cluster}`,
        })
          .then((response) => {
            if (response.status === 200) {
              suggest(response.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      renderItem: (item, search) => {
        const newSearch = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const part = new RegExp(`(${newSearch.split(' ').join('|')})`, 'gi');
        const title = item.title.replace(part, '<em>$1</em>');

        return `
          <div class="autocomplete-suggestion" data-url="${item.url.html()}" data-val="${item.title.html()}">
            <div class="title">
              ${title}
              ${item.brand ? `<span class="search-suggest-brand">${item.brand.html().toLowerCase()}</span>` : ''}
            </div>
            <span class="type" data-type="${item.type.html()}">${item.type.html()}</span>
          </div>`;
      },
      onSelect: (e, term, item) => {
        // Prevent url redirect so we have enough time to send the event.
        e.preventDefault();

        // Send the GTM event on click on a suggestion
        searchSuggestion(term, item);

        // Now that the event is sent, we can redirect.
        setTimeout(() => {
          document.location = item.dataset.url;
        }, 200);
      },
    });
  }
}
